import React, { useState } from "react";
import { gql, useQuery } from "@apollo/client";
import { Col, Row } from "reactstrap";
import Loader from "../../Loader";
import { error } from "../../Controllers/toast";

const LINE_INFO = gql`
  query ($Gateway_id: Int!, $date: Date!, $time_offset:Int!) {
    GetStringData(Gateway_id: $Gateway_id, date: $date,time_offset:$time_offset) {
      Eline
    }
  }
`;
const date = new Date();

const LineModalHeader = ({ Gateway_id, lang_choiced, gateway }) => {
  const [data, setData] = useState();
  // console.log(Gateway_id)
  const { loading } = useQuery(LINE_INFO, {
    variables: {
      Gateway_id,
      date,
      time_offset: new Date().getTimezoneOffset(),
    },
    onCompleted: (res) => {
      console.log(res.GetStringData, "is res.GetStringData");
      setData(res.GetStringData);
    },
    onError: (err) => {
      // console.log(err);
      error("مشکلی در دریافت اطلاعات رخ داده است!")

    },
    pollInterval: 60000,
  });
  return (
    <div className="string-label-bypanel">
      <Row className="content-label-bypanel smaller-font">
        <Col className="col-xs-4-bypanel  smaller-font col-sm-4 col-md-4 col-lg-4 col-xl-4 b-r-12 b-l-12 ">
          {lang_choiced.pages.byPanel.PanelGroup.Line.Modal.Iline} : {data ? <span style={{ fontSize: "16px" }}>{(gateway.group_data[0].Iline / 1000).toFixed(2)}</span> : "-"}
          <span style={{ fontSize: "16px" }} className="mr-1">A</span>
        </Col>
        <Col className="col-xs-4-bypanel  smaller-font col-sm-4 col-md-4 col-lg-4 col-xl-4 b-r-12 b-l-12 ">
          {lang_choiced.pages.byPanel.PanelGroup.Line.Modal.Vline} : {data ? <span style={{ fontSize: "16px" }}>{(gateway.group_data[0].Vline / 10).toFixed(1)}</span> : "-"}
          <span style={{ fontSize: "16px" }} className="mr-1">V</span>
        </Col>
        <Col className="col-xs-4-bypanel  smaller-font col-sm-4 col-md-4 col-lg-4 col-xl-4 b-r-12 b-l-12 ">
          {lang_choiced.pages.byPanel.PanelGroup.Line.Modal.Eline} : {data ? <span style={{ fontSize: "16px" }}>{(data.Eline / 1000).toFixed(2)}</span> : "-"}
          <span style={{ fontSize: "16px" }} className="mr-1">Kwh</span>
        </Col>
      </Row>
    </div>
  );
};

export default (LineModalHeader);
